export const MEDIA_EXAMPLE_LABEL = "Media Example";
export const MEDIA_EXAMPLES_LABEL = `${MEDIA_EXAMPLE_LABEL}s`;

export function getInstructionElementDisplayName(name: string): string {
    return name === "Media" ? MEDIA_EXAMPLES_LABEL : name;
}

export function getInstructionElementSingularDisplayName(name: string): string {
    if (name === "Media") return MEDIA_EXAMPLE_LABEL;
    return name.endsWith("s") ? name.slice(0, -1) : name;
}

export function getInstructionElementIdLabel(
    type: "Script" | "Media" | "Asset",
    id: number
): string {
    if (type === "Script") return `ID: ${id}`;
    const label = type === "Media" ? MEDIA_EXAMPLE_LABEL : type;
    return `${label} ID: ${id}`;
}
